window.Auth = {
	register: function ($form) {
		var route = $form.attr('action');
		var params = $form.serializeArray();
		var $btn = $("#modalLogin .submit-reg");

		$btn.attr('disabled', 'disabled').find('span').text('Регистрируемся...');

		var $msgError = $form.find('.msg-error');
		$msgError.hide();

		$.post(route, params, function (data) {
			$btn.removeAttr('disabled').find('span').text('Зарегистрироваться');

			if (!data.error) {
				if (data.redirect_to) {
					location.href = data.redirect_to;
				} else {
					location.reload();
				}
			} else {
				$msgError.text(data.msg).slideDown();
			}
		});
	},

	login: function ($form) {
		var route = $form.attr('action');
		var params = $form.serializeArray();
		var $btn = $("#auth-login .submit-login");

		$btn.attr('disabled', 'disabled').find('span').text('Входим...');

		var $msgError = $form.find('.msg-error');
		$msgError.hide();

		$.post(route, params, function (data) {
			$btn.removeAttr('disabled').find('span').text('Войти');

			if (!data.error) {
				if (data.redirect_to) {
					location.href = data.redirect_to;
				} else {
					location.reload();
				}
			} else {
				$msgError.text(data.msg).slideDown();
			}
		});
	},

	forget: function ($form) {
		var route = $form.attr('action');
		var params = $form.serializeArray();
		var $btn = $("#auth-forgot .submit-forgot");

		$btn.attr('disabled', 'disabled').find('span').text('Восстанавливаем...');

		var $msgError = $form.find('.msg-error');
		$msgError.hide();
		var $msgSuccess = $form.find('.msg-success');
		$msgSuccess.hide();

		$.post(route, params, function (data) {
			$btn.removeAttr('disabled').find('span').text('Восстановить пароль');

			if (!data.error) {
				$msgSuccess.text(data.msg).slideDown();
			} else {
				$msgError.text(data.msg).slideDown();
			}
		});
	},
};

$(document).ready(function () {
	var $modalLogin = $("#modalLogin");

	$modalLogin.find('[data-toggle=auth]').click(function () {
		let $self = $(this),
			$target = $($self.data('target'));

		if ($target.length) {
			$self.closest('.auth-tab').slideUp().addClass('collapse');
			$target.slideDown().removeClass('collapse');
		}

		return false;
	});

	$modalLogin.find('.company-type').change(function () {
		let $self = $(this),
			val = $self.val();

		var ogrnipTitle = $(this).find('option:selected').data('ogrn') || 'ОГРН';
		$modalLogin.find('.company-ogrn').attr('placeholder', ogrnipTitle);

		if (val === 'ip') {
			$('#company_kpp').attr('required', 'required').addClass('d-none');
		} else {
			$('#company_kpp').removeAttr('required').removeClass('d-none');
		}

		return false;
	});

	$(".form-register").submit(function () {
		Auth.register($(this));
		return false;
	});

	$("#form-login").submit(function () {
		Auth.login($(this));
		return false;
	});

	$("#form-reset-pass").submit(function () {
		Auth.forget($(this));
		return false;
	});

	$('.nav-register-type-tabs [data-form]').click(function () {
		$("#auth-reg").find('.submit-reg').attr('form', $(this).data('form'));
	});

	var socialAuthTm;
	var socialAuthWindow;
	$('.social-auth').click(function () {
		var link = $(this).attr('href');
		socialAuthWindow = popupwindow(link, 'Авторизация', 600, 600);
		socialAuthTm = setInterval(function () {
			if (socialAuthWindow.closed) {
				clearInterval(socialAuthTm);
				location.reload();
				//Auth.checkAuthAfterLogin();
			}
		}, 100);
		return false;
	});

	var tm;

	$(".autocomplete-inn").on('keyup change', function () {
		var self = this;
		var $form = $(this).closest('form');
		clearTimeout(tm);

		var inn = $(this).val(),
			$spinner = $('.spinner-input');

		$spinner.removeClass('is-loading');

		tm = setTimeout(function () {
			$.get('/companies/info_by_inn', {inn: inn}, function (data) {
				if (data.fields) {
					for(var field in data.fields) {
						var $input = $form.find('[data-autocomplete="'+field+'"]');
						if (!$input.val()) $input.val(data.fields[field]);
					}
				}
			});
		}, 1000);
	});
});